// extracted by css-extract-rspack-plugin
export default {"root":"ScrollArea-module__root___WblZB"};